import { jsxs as b, jsx as d } from "react/jsx-runtime";
import { useState as v, useCallback as O } from "react";
import { useDom as R } from "../../../../context/Dom.js";
import { useContextPopupState as g, useElementDimensions as j, useAutoCloseOnClick as k } from "./hooks.js";
function E({
  position: i = "bottom",
  children: t,
  closeOnPopupClick: r = !0,
  hover: n = !1,
  closeDelay: u = 200,
  anchorWidth: c = "max-content",
  anchorHeight: e = "max-content",
  boundingElementRef: o,
  enablePopup: l = !0
}) {
  const {
    openPopup: a,
    closePopup: p,
    isOpen: s,
    anchor: x,
    popup: m,
    anchorRef: f,
    setPopupDimensions: P,
    anchorProps: y,
    popupProps: C
  } = g({
    position: i,
    hover: n,
    closeDelay: u,
    boundingElementRef: o,
    enabled: l
  }), h = {
    isOpen: s,
    openPopup: a,
    closePopup: p,
    anchorDimensions: x,
    popupDimensions: m
  }, { createPortal: D } = R();
  return /* @__PURE__ */ b("div", { style: { height: e }, children: [
    /* @__PURE__ */ d(
      "div",
      {
        ref: f,
        style: {
          position: "relative",
          width: c,
          height: e
        },
        children: t.anchor({ ...h, anchorProps: y })
      }
    ),
    s && D(
      /* @__PURE__ */ d(
        w,
        {
          ...h,
          popupProps: C,
          onLayout: P,
          top: m.top,
          left: m.left,
          closeOnPopupClick: r,
          children: t.popup
        }
      ),
      f.current
    )
  ] });
}
function w({
  children: i,
  top: t = 0,
  left: r = 0,
  onLayout: n,
  popupProps: u,
  closeOnPopupClick: c,
  ...e
}) {
  const [o, l] = v(!1), a = O(
    (s) => {
      o && n(s), l(!0);
    },
    [o, n]
  ), p = j(a);
  return k({
    isOpen: e.isOpen,
    closePopup: e.closePopup,
    closeOnPopupClick: c,
    popupRef: p
  }), /* @__PURE__ */ d(
    "div",
    {
      ref: p,
      style: {
        position: "absolute",
        width: "max-content",
        height: "max-content",
        top: `${t}px`,
        left: `${r}px`,
        opacity: o ? 1 : 0,
        zIndex: 100
      },
      ...u,
      children: i({ ...e })
    }
  );
}
export {
  E as default
};
